import { Component, NgZone, OnDestroy, output } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { UserinfoContentComponent } from './userinfo-content/userinfo-content.component';
import { environment } from '../../../../environments/environment';
import { ScreensizeStateService } from '../../../state-management/services/screensize-state.service';
import { CoordinatesSystem, ScreenWidthBreakpoints } from '../../../state-management/model/enums/screen-size.enums';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-userinfo',
  standalone: true,
  templateUrl: 'userinfo.component.html',
  styleUrl: './userinfo.component.scss',
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatIconModule
  ]
})
export class UserinfoComponent implements OnDestroy {
  private dialogSubscription: Subscription = new Subscription();
  readonly buttonClicked = output<void>();
  timeoutId: any;
  public isSmallScreen$ = this.screenSize.isScreenSize(CoordinatesSystem.ScreenWidth, ScreenWidthBreakpoints.XSmall);

  constructor(
    public dialog: MatDialog,
    private ngZone: NgZone,
    private screenSize: ScreensizeStateService
  ) { }

  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      this.timeoutId = setTimeout(() => {
        this.ngZone.run(() => {
          this.openDialog();
        });
      }, 3000);
    });
  }

  ngOnDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    if (this.dialogSubscription) this.dialogSubscription.unsubscribe();
  }

  stopAnnimation() {
    this.buttonClicked.emit();
  }

  handleClick() {
    this.stopAnnimation();
    this.openDialog();
  }

  openDialog() {
    const dialogRef = this.dialog.open(UserinfoContentComponent, { panelClass: 'admin-theme' });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
}

